import React, { useEffect, useState } from 'react'
import { FormBox } from '../../../../../../components/AntdAddons';
import { Button, Col, Row, Tooltip, Form, Radio, Progress, Typography, Space, Flex } from 'antd';
import { InterestAssessmentBreadcrumb } from '../../../../../../config/BreadcrumbConfig';
import StronglyAgree from "../../../../../../assets/images/icon/examAnswerIcon/Agree.svg?react";
import Agree from "../../../../../../assets/images/icon/examAnswerIcon/stronglyAgree.svg?react";
import Unsure from "../../../../../../assets/images/icon/examAnswerIcon/Unsure.svg?react";
import StronglyDisagree from "../../../../../../assets/images/icon/examAnswerIcon/StronglyDisagree.svg?react";
import Disagree from "../../../../../../assets/images/icon/examAnswerIcon/Disagree.svg?react";
import { ArrowLeftOutlined, ArrowRightOutlined, QuestionCircleOutlined, VerticalLeftOutlined, VerticalRightOutlined } from '@ant-design/icons';
import { rules } from './Rules';
import { snakeCaseString } from '../../../../../../config/Global';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../../../store/app';
import BreadcrumbComponent from '../../../../CommonComponent/BreadcrumbComponent';
import { setHasAccessCodePopup } from '../../../../../../store/CommonSlice';


/**
 * Renders a form component for the interest assessment exam .
 *
 * @param {object} props - The props object containing the following properties:
 *   - steps: An array of steps for the exam.
 *   - current: The current step index.
 *   - setCurrent: A function to set the current step index.
 *   - getFirstSix: An array of the first six steps.
 *   - lastArrayData: The data of the last step.
 *   - btnLoading: A boolean indicating if the button is loading.
 *   - type: The type of the form (view or edit).
 * @return {JSX.Element} The rendered form component.
 */
const InterestAssessmentForm = (props: any) => {
    const dispatch: AppDispatch = useDispatch();

    const { steps, current, setCurrent, getFirstSix, lastArrayData, btnLoading, type, generalQuestionsLimit, tier1QuestionsLimit, industry_id, itemsPerPage } = props;
    const initialStoreData: any = useSelector((state: RootState) => state.AUTH.initialData);
    const totalQuestionsLimit = generalQuestionsLimit + tier1QuestionsLimit;
    console.log('total', steps.length, industry_id, generalQuestionsLimit, tier1QuestionsLimit, totalQuestionsLimit, lastArrayData?.index);
    const [options, setOption] = useState<any>();
    const svgIcons: any = {
        strongly_agree: <StronglyAgree />,
        agree: <Agree />,
        neutral: <Unsure />,
        disagree: <Disagree />,
        strongly_disagree: <StronglyDisagree />,
    };

    // Set interest assessment options type to display on form
    useEffect(() => {
        const initialData: any = sessionStorage.getItem("initialData")
        const initialDataJson = JSON.parse(initialData);
        if (initialDataJson) {
            setOption(initialDataJson?.interest_assessment_options_type)
        } else {
            setOption(initialStoreData?.interest_assessment_options_type)
        }
    }, [])

    const totalToltip = industry_id == 1 ?
        <>
            <Space direction="horizontal">
                48-52
                <Tooltip title="Subsequent questions will adapt based on your answers." trigger={'hover'} overlayClassName='examTooltip'>
                    <QuestionCircleOutlined style={{ fontSize: '20px' }} />
                </Tooltip>
            </Space>

        </>
        : 50;


    const calPercentage = () => {
        return Math.round((current / totalQuestionsLimit) * 100);
    }


    const totalNumberOfSections = Math.ceil((generalQuestionsLimit + tier1QuestionsLimit) / itemsPerPage);
    const currentSection = Math.ceil((totalNumberOfSections * (current + 1)) / (generalQuestionsLimit + tier1QuestionsLimit))

    return (
        <div className='examModal'>
            <section className="dashboard-sec">
                <div className='container-fluid'>
                    <div className='breadcrumb has-button'>
                        <BreadcrumbComponent key={1} items={InterestAssessmentBreadcrumb.path} />
                        <Button onClick={()=>dispatch(setHasAccessCodePopup(true))} className='common_Button green_border_common_btn'>Continue Your Career Journey</Button>
                    </div>
                    <div className="interesQnaSection">
                       

                        <div className='ansListRadiobtn'>
                            <div className='questions-section-title notranslate'>Section {currentSection}</div>
                            <div className='questions-page-title notranslate'>Questions {current + 1} - {(current + itemsPerPage) > totalQuestionsLimit ? totalQuestionsLimit : (current + itemsPerPage)}</div>
                            <FormBox
                                layout="vertical"
                                autoComplete="off"
                                form={props.form}
                                id={props.id}
                                onFinish={props.nextButton}
                                className="userProfile commanDrawer"
                            >

                                {getFirstSix.map((item: any, index: any) => {
                                    return (
                                        <div className="radioGrpExambox" key={index}>
                                            <Row align={'middle'} className='radioGrpExam'>
                                                <Col sm={24} className='questions'>
                                                    <div className="step_content"> <span className='currentAns notranslate'>Q.{item.index}</span> <span className='currentQuestion'>{item?.title}</span></div>

                                                </Col>

                                                <Col sm={24} className='answers'>
                                                    <Form.Item name={item?.question_id}
                                                        rules={props.type !== "view" ? rules.answer() : []}

                                                    >
                                                        <Radio.Group className='examRadioGrp' disabled={(steps.length > generalQuestionsLimit && item.disabled || type === "view") ? true : false}>
                                                            <div className='radioGrpExamIcon'>
                                                               {options?.map((contentItem: any, index: number) => {
                                                                    return (
                                                                        <Radio value={contentItem.id} key={index} >
                                                                            <div className={`${snakeCaseString(contentItem.title)} image`} >
                                                                                {/* <Tooltip placement="top" title={contentItem?.title} overlayClassName='examTooltip' > */}
                                                                                {/* {svgIcons[snakeCaseString(contentItem.title).replace(" ", "")]} */}
                                                                                {contentItem.title}
                                                                                {/* </Tooltip> */}
                                                                            </div>
                                                                        </Radio>
                                                                    )
                                                                })}
                                                            </div>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Col>

                                            </Row>
                                        </div>
                                    )
                                })
                                }
                                <div className="logInBtn">
                                    {current >= 1 &&
                                        <Button className='common_Button green_border_common_btn' onClick={() => { setCurrent(current - itemsPerPage) }}>Back </Button>}
                                    {lastArrayData?.index === totalQuestionsLimit
                                        ? <Button className='common_Button green_border_common_btn next-btn' form={props.id} loading={btnLoading} htmlType='submit'>Finish</Button>
                                        : <Button className='common_Button green_border_common_btn next-btn' form={props.id} loading={btnLoading} htmlType='submit'>Next</Button>
                                    }
                                </div>
                            </FormBox>
                        </div>
                    </div>

                </div>
            </section>
        </div>

    )
}

export default InterestAssessmentForm